function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBreakpoints } from "../Breakpoints";
import { isTruthy, isObject } from "../../utils/is";
var DEFAULT_PADDING = 8;
var LARGE_PADDING = 12;
var VALID_START_PADDINGS = [
    'start',
    'paddingStart',
    'left',
    'paddingLeft'
];
var VALID_END_PADDINGS = [
    'end',
    'paddingEnd',
    'right',
    'paddingRight'
];
var isNumber = function(padding) {
    return typeof padding === 'number';
};
var hasValidStartPaddingValue = function(padding) {
    return Object.keys(padding).some(function(p) {
        return VALID_START_PADDINGS.includes(p);
    });
};
var hasValidEndPaddingValue = function(padding) {
    return Object.keys(padding).some(function(p) {
        return VALID_END_PADDINGS.includes(p);
    });
};
var useStyle = function(param) {
    var zIndex = param.zIndex, componentDefaults = param.componentDefaults, componentS = param.s, componentM = param.m, componentL = param.l, componentXL = param.xl, isRtl = param.isRtl;
    var ref = defineStartAndEnd(isRtl), start = ref.start, end = ref.end;
    var breakpoints = useBreakpoints();
    var colBase = {
        zIndex: zIndex,
        direction: isRtl === true && 'rtl' || isRtl === false && 'ltr' || 'inherit',
        boxSizing: 'border-box',
        position: 'relative',
        display: 'block',
        flexShrink: 0,
        flexGrow: 0,
        flexBasis: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'stretch',
        minHeight: 'inherit'
    };
    var resolveDefaultPaddingWithOverrides = function(colStyles, defaultPadding) {
        return expandPadding(_objectSpread({}, colStyles, {
            padding: _objectSpread({}, !isTruthy(colStyles.padding) && {
                start: defaultPadding,
                end: defaultPadding
            }, isNumber(colStyles.padding) && {
                start: colStyles.padding,
                end: colStyles.padding
            }, isObject(colStyles.padding) && _objectSpread({}, colStyles.padding, !hasValidStartPaddingValue(colStyles.padding) && {
                start: defaultPadding
            }, !hasValidEndPaddingValue(colStyles.padding) && {
                end: defaultPadding
            }))
        }));
    };
    var responsiveCols = function() {
        var defaults = resolveDefaultPaddingWithOverrides(componentDefaults, DEFAULT_PADDING);
        var userS = _objectSpread({}, expandPadding(componentDefaults), expandPadding(componentS));
        var userM = _objectSpread({}, userS, expandPadding(componentM));
        var userL = _objectSpread({}, userM, expandPadding(componentL));
        var userXl = _objectSpread({}, userL, expandPadding(componentXL));
        var resolvedL = resolveDefaultPaddingWithOverrides(userL, LARGE_PADDING);
        var resolvedXl = _objectSpread({}, resolvedL, userXl);
        var buildStyleAtBreakpoint = function(colStyle) {
            var _obj;
            var resolvedColStyles = _objectSpread({}, colStyle.flex, widthProperties(colStyle.width, colStyle.minWidth), (_obj = {}, _defineProperty(_obj, "margin".concat(start), convertWidthValue(colStyle.offset)), _defineProperty(_obj, "margin".concat(end), convertWidthValue(colStyle.offsetEnd)), _obj));
            var padding = colStyle.padding;
            if (!isTruthy(padding)) {
                return resolvedColStyles;
            }
            return _objectSpread({}, resolvedColStyles, isTruthy(padding.paddingTop) && {
                paddingTop: "".concat(padding.paddingTop, "px")
            }, isTruthy(padding.paddingBottom) && {
                paddingBottom: "".concat(padding.paddingBottom, "px")
            }, isTruthy(padding.paddingStart) && _defineProperty({}, "padding".concat(start), "".concat(padding.paddingStart, "px")), isTruthy(padding.paddingEnd) && _defineProperty({}, "padding".concat(end), "".concat(padding.paddingEnd, "px")));
        };
        var _obj1;
        return _objectSpread({}, buildStyleAtBreakpoint(defaults), (_obj1 = {}, _defineProperty(_obj1, "@media (min-width: ".concat(breakpoints.s, "px)"), buildStyleAtBreakpoint(userS)), _defineProperty(_obj1, "@media (min-width: ".concat(breakpoints.m, "px)"), buildStyleAtBreakpoint(userM)), _defineProperty(_obj1, "@media (min-width: ".concat(breakpoints.l, "px)"), buildStyleAtBreakpoint(resolvedL)), _defineProperty(_obj1, "@media (min-width: ".concat(breakpoints.xl, "px)"), buildStyleAtBreakpoint(resolvedXl)), _obj1));
    };
    return _objectSpread({}, colBase, responsiveCols());
};
var expandPadding = function(colStyles) {
    if (!isTruthy(colStyles)) {
        return;
    }
    var padding = colStyles.padding;
    if (!isTruthy(padding)) {
        return colStyles;
    }
    if (isNumber(padding)) {
        return _objectSpread({}, colStyles, {
            padding: {
                paddingEnd: padding,
                paddingStart: padding
            }
        });
    }
    return _objectSpread({}, colStyles, {
        padding: _objectSpread({}, isTruthy(padding.paddingTop) && {
            paddingTop: padding.paddingTop
        }, isTruthy(padding.top) && {
            paddingTop: padding.top
        }, isTruthy(padding.paddingBottom) && {
            paddingBottom: padding.paddingBottom
        }, isTruthy(padding.bottom) && {
            paddingBottom: padding.bottom
        }, isTruthy(padding.paddingRight) && {
            paddingEnd: padding.paddingRight
        }, isTruthy(padding.right) && {
            paddingEnd: padding.right
        }, isTruthy(padding.paddingEnd) && {
            paddingEnd: padding.paddingEnd
        }, isTruthy(padding.end) && {
            paddingEnd: padding.end
        }, isTruthy(padding.paddingStart) && {
            paddingStart: padding.paddingStart
        }, isTruthy(padding.start) && {
            paddingStart: padding.start
        }, isTruthy(padding.paddingLeft) && {
            paddingStart: padding.paddingLeft
        }, isTruthy(padding.left) && {
            paddingStart: padding.left
        })
    });
};
var convertWidthValue = function(numWidth) {
    if (typeof numWidth === 'number') {
        if (numWidth > 0 && numWidth <= 1) {
            return "".concat(numWidth * 100, "%");
        }
        return "".concat(numWidth, "px");
    }
    return 0;
};
var widthProperties = function(numWidth, numMinWidth) {
    var minWidth = numMinWidth !== undefined && {
        minWidth: convertWidthValue(numMinWidth)
    };
    if (typeof numWidth === 'number') {
        if (numWidth > 0 && numWidth <= 1) {
            return _objectSpread({}, minWidth, {
                width: "".concat(numWidth * 100, "%"),
                flexGrow: 0
            });
        }
        return _objectSpread({}, minWidth, {
            width: "".concat(numWidth, "px"),
            flexGrow: 0
        });
    }
    if (numWidth === 'content') {
        return _objectSpread({}, minWidth, {
            width: 'auto',
            flexGrow: 0,
            flexShrink: 0
        });
    }
    return _objectSpread({}, minWidth, {
        width: 0,
        flexGrow: 1
    });
};
var defineStartAndEnd = function(isRtl) {
    return isRtl ? {
        start: 'Right',
        end: 'Left'
    } : {
        start: 'Left',
        end: 'Right'
    };
};
export default useStyle;
